import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Home, MessageCircle } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-paper">
      <Header />

      <main className="section">
        <div className="container-site">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[13px] font-medium text-ink/60 transition hover:text-ink"
          >
            <ArrowLeft size={14} strokeWidth={1.75} />
            На главную
          </Link>

          <div className="mt-16 grid gap-12 md:grid-cols-12">
            <div className="md:col-span-7">
              <span className="eyebrow">404</span>
              <h1 className="display mt-6 text-[clamp(3rem,8vw,6rem)] leading-[0.95] tracking-tightest">
                Страница потерялась
              </h1>
              <p className="mt-8 max-w-xl text-[16px] leading-relaxed text-ink/70">
                Адрес <code className="bg-white px-2 py-0.5 text-[13px] text-orange">{pathname}</code>
                {' '}не существует или был перемещён. Бывает.
              </p>

              <div className="mt-10 flex flex-wrap gap-3">
                <Link to="/" className="btn-primary inline-flex items-center gap-2">
                  <Home size={15} strokeWidth={1.75} />
                  На главную
                </Link>
                <Link to="/support" className="btn-outline inline-flex items-center gap-2">
                  <MessageCircle size={15} strokeWidth={1.75} />
                  Написать в&nbsp;поддержку
                </Link>
              </div>
            </div>

            <aside className="md:col-span-5">
              <div className="border border-line bg-white p-6">
                <div className="text-[11px] font-medium uppercase tracking-[0.14em] text-ink/50">
                  Куда чаще всего хотят попасть
                </div>
                <ul className="mt-5 divide-y divide-line border-t border-line">
                  {[
                    { to: '/', title: 'Главная', text: 'Что такое Resstro и как это работает' },
                    { to: '/#pricing', title: 'Тарифы', text: 'Стоимость и сравнение планов' },
                    { to: '/#features', title: 'Возможности', text: 'Касса, меню, аналитика, склад' },
                    { to: '/support', title: 'Поддержка', text: 'WhatsApp, email и FAQ' },
                    { to: '/contacts', title: 'Контакты', text: 'Реквизиты ИП и&nbsp;документы' },
                    { to: '/changelog', title: 'История обновлений', text: 'Что нового в&nbsp;продукте' },
                  ].map((l) => (
                    <li key={l.to}>
                      <Link
                        to={l.to}
                        className="group flex items-start justify-between gap-4 py-4 transition"
                      >
                        <div>
                          <div className="text-[14px] font-medium text-ink group-hover:text-orange">
                            {l.title}
                          </div>
                          <div
                            className="mt-0.5 text-[12.5px] text-ink/55"
                            dangerouslySetInnerHTML={{ __html: l.text }}
                          />
                        </div>
                        <ArrowLeft
                          size={14}
                          strokeWidth={1.75}
                          className="mt-1 shrink-0 rotate-180 text-ink/40 transition group-hover:text-ink"
                        />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
